export default __webpack_public_path__ + "static/media/download.db03760a.svg";